import React from 'react';
import './OngoingProjects.css';

const OngoingProjects = () => {
  return (
    <div className="projects">
      <div className="projects-wrapper">
        <h2 className="projects-title">🚧 Ongoing Projects</h2>
        <p className="projects-intro">
          At Igbo-Eze North Local Government Council, we believe in development you can see, feel, and benefit from.
          Guided by our 2025–2029 Medium Term Development Plan, we are implementing a wide range of transformational
          projects across all sectors — from roads and schools to health centres and markets.
        </p>

        <section className="project-section">
          <h3>🏗️ Infrastructure & Roads</h3>
          <ul>
            <li>Rehabilitation of 300km rural road network across 20 wards</li>
            <li>Massive rehabilitation of community link roads</li>
            <li>Reconstruction of 2km Ogrute–INEC–Imufu Road</li>
            <li>Maintenance of MCC Road and other major access routes</li>
          </ul>
        </section>

        <section className="project-section">
          <h3>⚡ Electricity & Street Lighting</h3>
          <ul>
            <li>Extension of rural electrification to underserved communities</li>
            <li>Installation of 700 units of solar-powered streetlights</li>
            <li>Procurement and installation of 20 high-capacity transformers</li>
          </ul>
        </section>

        <section className="project-section">
          <h3>💧 Water & Sanitation</h3>
          <ul>
            <li>Construction and renovation of 35 solar-powered water facilities</li>
            <li>Installation of public toilets in schools and communities</li>
            <li>Ongoing WASH training for community health and safety teams</li>
          </ul>
        </section>

        <section className="project-section">
          <h3>🏥 Healthcare Facilities</h3>
          <ul>
            <li>Upgrading of 50 primary healthcare centres with modern equipment and trained staff</li>
            <li>Implementation of community-based health insurance schemes</li>
            <li>Awareness campaigns on hygiene and disease prevention</li>
          </ul>
        </section>

        <section className="project-section">
          <h3>🏫 Education & Skills Development</h3>
          <ul>
            <li>Renovation of Amachalla and Aji schools</li>
            <li>Provision of educational materials to 10,000 students annually</li>
            <li>Vocational training for youths and women in trades like tailoring, catering, and cosmetology</li>
            <li>Scholarships and financial assistance for over 200 students annually</li>
          </ul>
        </section>

        <section className="project-section">
          <h3>🛍️ Markets & Economic Development</h3>
          <ul>
            <li>Expansion and restructuring of Eke Ozzi and Nkwo Aji markets</li>
            <li>Provision of 6,000 lock-up shops with solar power, boreholes, abattoirs, and public toilets</li>
            <li>Support to over 1,000 MSMEs with access to microfinance and training</li>
            <li>Ongoing development of farm estates in four wards</li>
          </ul>
        </section>

        <section className="project-section">
          <h3>🛡️ Security & Governance</h3>
          <ul>
            <li>Provision of logistics and surveillance systems for Neighbourhood Watch, Forest Guards, and Police</li>
            <li>Construction of administrative buildings, legislative chambers, and security posts</li>
            <li>Training of law enforcement in community policing and conflict resolution</li>
            <li>Establishment of a citizen feedback mechanism and website (this platform)</li>
          </ul>
        </section>

        <p className="projects-conclusion">
          These projects reflect our commitment to accountable governance, sustainable growth, and people-centered
          service delivery. 📌 Check this page regularly for updates, photos, and impact stories from across our
          communities.
        </p>
      </div>
    </div>
  );
};

export default OngoingProjects;